import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SEOHead = ({ page = 'home' }) => {

  const { t, i18n } = useTranslation('seo');
  const location = useLocation();
  const currentLang = i18n.language;
  const isRussian = currentLang === 'ru';
  const baseUrl = 'https://safe-gpt.co';
  const fullUrl = page === 'home'
    ? (isRussian ? `${baseUrl}/ru` : baseUrl)
    : `${baseUrl}${location.pathname}`;

  const seoData = {
    title: t(`seo.${page}.title`),
    description: t(`seo.${page}.description`),
    keywords: t(`seo.${page}.keywords`),
    ogTitle: t(`seo.${page}.og.title`),
    ogDescription: t(`seo.${page}.og.description`),
    ogImage: t(`seo.${page}.og.image`),
    ogUrl: page === 'home' ? fullUrl : t(`seo.${page}.og.url`),
    ogSiteName: t(`seo.${page}.og.siteName`),
    ogLocale: t(`seo.${page}.og.locale`),
    twitterCard: t(`seo.${page}.twitter.card`),
    twitterTitle: t(`seo.${page}.twitter.title`),
    twitterDescription: t(`seo.${page}.twitter.description`),
    twitterImage: t(`seo.${page}.twitter.image`)
  };

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      <meta name="keywords" content={seoData.keywords} />
      <meta name="robots" content="index, follow" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={seoData.ogTitle} />
      <meta property="og:description" content={seoData.ogDescription} />
      <meta property="og:image" content={`${baseUrl}${seoData.ogImage}`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={seoData.ogUrl} />
      <meta property="og:site_name" content={seoData.ogSiteName} />
      <meta property="og:locale" content={seoData.ogLocale} />
      <meta name="twitter:card" content={seoData.twitterCard} />
      <meta name="twitter:title" content={seoData.twitterTitle} />
      <meta name="twitter:description" content={seoData.twitterDescription} />
      <meta name="twitter:image" content={`${baseUrl}${seoData.twitterImage}`} />
      <meta name="theme-color" content="#36d5e8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="canonical" href={fullUrl} />
      {page === 'home' && (
        <>
          <link rel="alternate" hrefLang="uk" href={baseUrl} />
          <link rel="alternate" hrefLang="ru" href={`${baseUrl}/ru`} />
          <link rel="alternate" hrefLang="x-default" href={baseUrl} />
        </>
      )}
    </Helmet>
  );
};

export default SEOHead;